<div>

  <title-tile [titleTile]="marsTitleTileData"></title-tile>

  <metric-tile [metricTile]="cityOnMarsTileData"></metric-tile>

  <metric-tile [metricTile]="whyMarsData"></metric-tile>

  <stats [stats]="marsStats"></stats>

  <metric-tile [metricTile]="starshipTile"></metric-tile>

  <content-hub-link *ngIf="contentHubEnabled" [contentHubLink]="contentHubLink$ | async"></content-hub-link>

  <video-tile [videoTile]="landingOnMarsTileData"></video-tile>
  
  <video-tile [videoTile]="mars2026TileData"></video-tile>

  <metric-tile [metricTile]="marsMissionsData"></metric-tile>

  <swiper [swiperData]="firstHumansSwiperData"></swiper>

  <swiper [swiperData]="cityOnMarsSwiperData"></swiper>

  <page-footer [pageFooterData]="marsPageFooterData"></page-footer>

</div>